import { resolveOriginRegion } from "@shared/lib/origin/resolveOriginRegion"

import styles from "./slider.module.css"

const sharedSlideProps = {
    buttonClassName: styles.button,
    buttonText: 'sign_up',
}

const paymentsSlide = {
    className: styles.slide1,
    title: 'payments',
    description: 'multi_currency_account',
    components: {
        br: <br />,
    },
    ...sharedSlideProps,
}

const ukCardSlide = {
    className: styles.slide2,
    title: 'banxe_card',
    description: 'banxe_card_uk_description',
    components: {
        br: <br />,
    },
    ...sharedSlideProps,
}

const ibanSlide = {
    className: styles.slide4,
    title: 'iban',
    description: 'get_dedicated_iban',
    ...sharedSlideProps,
}

export const getSlides = (originDomain?: string | null, isUkUser = false) => {
    const origin = resolveOriginRegion(originDomain)

    if (origin === 'uk') return [paymentsSlide, ukCardSlide, ibanSlide]
    if (origin === 'com') return [paymentsSlide, ibanSlide]
    if (isUkUser) return [paymentsSlide, ukCardSlide, ibanSlide]

    return [paymentsSlide, ibanSlide]
}
